export enum CellType {
    textInput = "textInput",
    textInputWithMenuButton = "textInputWithMenuButton",
    readOnlyTextWithMenuButton = "readOnlyTextWithMenuButton",
    singleSelect = "singleSelect",
    multiSelect = "multiSelect",
    datePicker = "datePicker",
    readOnlyText = "readOnlyText",
    readOnlyDate = "readOnlyDate",
    redirect = "redirect",
    checkbox = "checkbox",
    numberInput = "numberInput",
    dateTimePicker = "dateTimePicker",
}
